import { toast } from 'react-toastify';

export default function errorHandle(error) {
    console.log(error);
    if (error.response.data) {
        console.log(error.response.data.message);
        toast.error(error.response.data.message);
    }
}
